import ThirdPartyUpdatedModal from "./ThirdPartyUpdatedModal.container";

export default ThirdPartyUpdatedModal;
